<template lang="pug">
#bloco-visao-geral
    h2 Visão geral do imóvel
    el-card.box-card
        .visao-geral-blocos
            .visao-geral-bloco
                .bloco-topo
                    h3 Nome da Fazenda
                    span Fazenda Rio das Cobras
                div
                    h3 CAR’s vinculados
                    span.lista-scroll
                        .item MT-5100...2920D97B0

            .visao-geral-bloco
                .bloco-topo
                    h3 Pessoas
                    span.lista-scroll
                        .item Rosmari Garcia Sistilli
                div
                    h3 CPF/CNPJ das pessoas
                    span.lista-scroll
                        .item 758.292.741-91

            .visao-geral-bloco
                .bloco-topo
                    h3 Bioma
                    span Amazônia
                div
                    h3 Localidade
                    span Apiacás /MT

            .visao-geral-bloco
                .bloco-topo
                    h3 Área do imóvel
                    span 1.288,31 ha
                div
                    h3 Módulos Fiscais
                    span.lista-scroll
                        .item 12,86

            .visao-geral-bloco
                .bloco-topo
                    h3 Data de cadastro no SICAR
                    span 20/10/2014
                .coordenadas
                    h3 Coordenadas centroides
                    span Latitude: 09°12'10,78" S
                    span Longitude: 58°02'59,07" O
</template>

<script>
export default {
    name: 'BlocoVisaoGeral',
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
#bloco-visao-geral {
    h2 {
        font-weight: 600;
        margin-top: 30px;
        margin-bottom: 12px;
        color: #3b3b3b;
        font-size: 16px;
    }
    .visao-geral-blocos {
        display: flex;
        justify-content: space-between;
        gap: 12px;
        .visao-geral-bloco {
            h3 {
                font-size: 14px;
                color: #3b3b3b;
                font-weight: 400;
                margin-bottom: 4px;
            }
            span {
                font-size: 14px;
                color: var(--primary);
                font-weight: 600;
            }
            .coordenadas {
                display: flex;
                flex-direction: column;
            }
        }
    }
    .bloco-topo {
        margin-bottom: 10px;
        min-height: 110px;
    }
    .lista-scroll {
        max-height: 110px;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        min-height: 70px;
        padding: 0px;
    }
}
</style>
